export default __webpack_public_path__ + "03a1f7d83a2ead27702534157cf1e2dd.svg";